import { motion } from 'framer-motion'
import React, { PropsWithChildren } from 'react'

interface IProps extends PropsWithChildren {
  onClick?: () => void
}

export const BounceContainer = ({ children, onClick }: IProps) => {
  return (
    <motion.div
      transition={{
        type: 'spring',
        bounce: 0.5,
      }}
      style={{ cursor: 'pointer', display: 'flex' }}
      whileHover={{ scale: 1 + 0.01 }}
      whileTap={{ scale: 1 - 0.01 }}
      onClick={onClick}
    >
      {children}
    </motion.div>
  )
}
